export default {
    NAMESPACE: "DirectlyRTM",
    LANDING_URL_KEY: "directlyLandingUrl",
    EMAIL_TRACKING_PARAMETER: "et",
};
